import {httpGet, httpPost} from './http.service';
import {ICalculator} from '../incase-domain/elements/calculator';

export const fetchCalculators = (searchString?: string): Promise<ICalculator[]> => {
    return httpGet(`editor/calculator${searchString ? `?searchString=${searchString}` : ''}`);
};

export const fetchCalculatorById = (id: string): Promise<ICalculator> => {
    return httpGet(`editor/calculator/${id}`);
};

export const calculateResult = (id: string, inputs: Record<string, number | string>): Promise<number> => {
    return httpPost(`editor/calculator/calculate/${id}`, inputs);
};
